import React, { useMemo, FC } from 'react';
import { t } from 'i18next';

import UButton from 'Components/unit/UButton/UButton';
import withTooltip from 'Components/hoc/withTooltip/withTooltip';
import { CampaignScheduling } from 'Store/entities/activity/activity.type';

import { sharedPanelFormStyles } from '../SchedulePanel.style';

const NewButtonWithTooltip = withTooltip(UButton);

export type ScheduleModeFormProps = {
  currentMode: CampaignScheduling['mode'];
  editable?: boolean;
  onChange: (mode: CampaignScheduling['mode']) => void;
};

export const ScheduleModeForm: FC<ScheduleModeFormProps> = ({ currentMode, editable = true, onChange }) => {
  const item = useMemo(() => {
    if (currentMode === 'manual') {
      return {
        convertText: t('activities:scheduling.side_panel.convert_to_random'),
        subtitle: t('activities:scheduling.side_panel.manual_mode_subtitle'),
        icon: 'random-order' as const,
        tooltip: {
          tooltipContent: !editable
            ? t('activities:scheduling.side_panel.cannot_convert_warning')
            : t('activities:scheduling.side_panel.random_mode_tooltip'),
          tooltipPosition: 'right',
          tooltipEnabled: true,
          tooltipMaxWidth: 243,
        },
      };
    }

    return {
      convertText: t('activities:scheduling.side_panel.convert_to_manual'),
      subtitle: t('activities:scheduling.side_panel.random_mode_subtitle'),
      icon: 'manual-order' as const,
      tooltip: {
        tooltipContent: !editable
          ? t('activities:scheduling.side_panel.cannot_convert_warning')
          : t('activities:scheduling.side_panel.manual_mode_tooltip'),
        tooltipPosition: 'right',
        tooltipEnabled: true,
        tooltipMaxWidth: 243,
      },
    };
  }, [currentMode, editable]);

  const handleModeChange = () => {
    onChange(currentMode === 'manual' ? 'random' : 'manual');
  };

  return (
    <div style={sharedPanelFormStyles.box}>
      <h4 style={sharedPanelFormStyles.title}>{t('activities:scheduling.side_panel.mode_title')}</h4>
      <p style={sharedPanelFormStyles.subtitle}>{item.subtitle}</p>
      <div style={sharedPanelFormStyles.element}>
        <NewButtonWithTooltip
          tooltipContent={item.tooltip.tooltipContent}
          tooltipPosition={item.tooltip.tooltipPosition}
          tooltipEnabled={item.tooltip.tooltipEnabled}
          tooltipMaxWidth={item.tooltip.tooltipMaxWidth}
          text={item.convertText}
          type="accentuated"
          disabled={!editable}
          style={{ width: '100%' }}
          leftIcon={item.icon}
          onClick={handleModeChange}
          ghost
        />
      </div>
    </div>
  );
};
